import { cn } from '@/shared/lib'

import { Image, type ImageProps } from '../image'

export type Props = Omit<ImageProps, 'width' | 'height'> & {
  ratio: '1:1' | '2:1' | '3:2' | '4:3' | '16:9'
  size: number
  rounded?: boolean
}

export const Thumbnail = ({
  src,
  alt,
  ratio = '1:1',
  size = 100,
  rounded = false,
  className,
  ...restProps
}: Props) => {
  const width = (() => {
    if (ratio === '1:1') return size
    if (ratio === '2:1') return Math.ceil(size * 2)
    if (ratio === '3:2') return Math.ceil((size * 3) / 2)
    if (ratio === '4:3') return Math.ceil((size * 4) / 3)
    else return size * 2
  })()

  return (
    <Image
      src={src}
      alt={alt}
      className={cn('shrink-0', className, {
        'rounded-sm': rounded,
      })}
      width={width}
      height={size}
      {...restProps}
    />
  )
}
